import React from 'react'
import PropTypes from 'prop-types'

import { Box, Copy, WebviewWrapper } from '@elparking/components'
import Summary from '../../../components/Summary'
import RentVehicleExtraInfo from '../../../components/RentalCarContract/RentVehicleExtraInfo'
import NeededDocs from '../../../components/RentalCarContract/NeededDocs'
import ContractExtraInfo from '../../../components/RentalCarContract/ContractExtraInfo'
import { FormattedMessage } from 'react-intl'
import ExtraInfoBlockWithLoader from '../ExtraInfoBlock'
import { SimpleExtraServiceBox } from '../../../components/ExtraServiceBox'
import LinkButton from '../../../components/LinkButton'
import { MUTUAMAS_SERVICES_CONDITIONS } from 'commons/js/constants'
import { bookingDetailPageName } from 'commons/js/services/analytics/TealiumEventsCollection/rentalCar'
import InfoAgeRequirements from 'rental-car-contract/js/components/RentalCarContract/InfoAgeRequirements'

const DetailsBlock = ({
    booking,
    showModal,
    isMutuaUser,
    cancelBlock,
    editBookingBlock,
    token,
}) => {
    const { fixedCoverages } = booking
    return <Box pt={['2em', '0']}>
        <Summary
          id={booking.id}
          supplierReference={booking.supplierReference}
          startRent={{ date: booking.startDate, place: booking.originPOI }}
          endRent={{ date: booking.endDate, place: booking.destinationPOI }}
          seller={booking.seller}
          car={booking.car}
          token={token}
          features={booking.insuranceConfigs}
          onCancel={showModal}
          cancelBlock={cancelBlock}
          editBookingBlock={editBookingBlock}
          isCancelable={booking.isCancelable && !booking.cancelled}
          cancelled={booking.cancelled}
          timeZone={booking.timeZone}
          pageName={bookingDetailPageName}/>
        {booking.isCancelable && !booking.cancelled && <Copy as='span' fontSize='small' fontWeight='regular'>
            <FormattedMessage defaultMessage='Puedes cancelar tu reserva en cualquier momento y sin coste adicional. Consulta las {conditionsLink}.' values={{
                conditionsLink: <Copy as='a' href={MUTUAMAS_SERVICES_CONDITIONS} fontSize='small' rel='noopener noreferrer' target='_blank' textDecoration='underline'><FormattedMessage defaultMessage='condiciones de alquiler'/></Copy>,
            }} />
        </Copy>}
        {fixedCoverages.map(extra => <Box width={['100%', 'calc(50% - 0.5em)']} key={`coverage_${extra.id}`} padding='0.5em 0em'>
            <SimpleExtraServiceBox
              title={extra.name}
              description={extra.description}
              icon={extra.logoUrl}/>
        </Box>)}
        {!booking.cancelled && <>
            <RentVehicleExtraInfo
              urlCheckIn={booking.urlCheckIn}
              originPOI={booking.originPOI}
              destinationPOI={booking.destinationPOI}
              showContactButtons/>
            <NeededDocs companyName={booking.seller.name} onSendDocs={showModal} showImage={false} textColor='accent' idSupplier={booking.seller.id}/>
            <WebviewWrapper ><InfoAgeRequirements mt='1em' /></WebviewWrapper>
            <ContractExtraInfo items={booking.footerConfig} />
            <ExtraInfoBlockWithLoader
              isMutuaUser={isMutuaUser}
              booking={booking}/>
            {booking.supplierWeb && <Box width='100%'>
                <LinkButton href={booking.supplierWeb} target='_blank' rel='noopener noreferrer'>
                    <FormattedMessage defaultMessage='Visitar web de {sellerName} ' values={{
                        sellerName: booking.supplierName,
                    }}/>
                </LinkButton>
            </Box>}
        </>}
    </Box>
}
DetailsBlock.propTypes = {
    booking: PropTypes.object,
    showModal: PropTypes.func,
    cancelBlock: PropTypes.func,
    editBookingBlock: PropTypes.func,
    isMutuaUser: PropTypes.bool,
    token: PropTypes.string,
}

DetailsBlock.defaultProps = {
    booking: {},
    showModal: () => {},
}
export default DetailsBlock
